import React from 'react';
import _ from 'lodash';
import { Field } from 'redux-form';
import { FormattedMessage } from 'translations';
import { Layout } from 'app/components/base/Layout';
import InteractiveInfoBlock from 'app/components/base/InteractiveInfoBlock';
import CompactInput from 'app/components/base/CompactInput';
import { RETURN_DATE_SELECTED, RETURN_DATETIME_FIELD_NAME } from 'app/constants';
import builder from '../builder';

import style from './style.css';


// Constants
const TIME_ICON = { name: 'time', family: 'mozio' };
const messages = {
  text: { id: 'BOOK_TRIP.SELECT_RETURNING_DATE' },
  button: { id: 'BOOK_TRIP.SELECT_DATE' }
};

/**
 * Desktop version of return trip selector.
 *
 * When user change the date in datetime picker `return_datetime` field in
 * parent redux-form will be changed.
 *
 * When user click to `Select date` button `props.input.onChange`
 * will be called with `RETURN_DATE_SELECTED` constant. Also `props.onSelectDate`
 * will be called.
 */
export class DesktopReturnDate extends React.Component {
  handleClickSelect = () => {
    const {
      input: { onChange },
      onDateSelected = _.noop
    } = this.props;

    onChange(RETURN_DATE_SELECTED);
    onDateSelected();
  }

  get button() {
    return [{
      onClick: this.handleClickSelect,
      title: <FormattedMessage {...messages.button} />
    }];
  }

  get content() {
    const { minDate } = this.props;
    return (
      <Layout
        className={style.block}
        size="noshrink"
        align="start center"
        nowrap
      >
        <span className={style.block__text}>
          <FormattedMessage {...messages.text} />
        </span>
        <Field
          opened
          component={CompactInput}
          icon={TIME_ICON}
          type="date"
          name={RETURN_DATETIME_FIELD_NAME}
          minDate={minDate}
          showDropDownArrow={false}
          compact
        />
      </Layout>
    );
  }

  render() {
    return (
      <InteractiveInfoBlock
        contentAlign="center start"
        text={this.content}
        buttons={this.button}
      />
    );
  }
}

// TODO: move to Flow types
// DesktopReturnDate.propTypes = {
//   onDateSelected: PropTypes.func,
//   input: PropTypes.object,
//   minDate: PropTypes.object
// };

export default builder(DesktopReturnDate);
